/**
 * Faixa de relógio desregulado — GUPM-336.
 *
 * A renovação resiliente da sessão esconde o sintoma (o painel não trava mais), mas o
 * PC continua com a hora errada — e a hora carimba TARP, troca de plantão e leitura
 * de certificado HTTPS. A faixa torna o problema visível para quem pode consertar.
 * Não é dispensável: some quando o relógio é acertado (o próximo token mede de novo).
 */
import { Banner } from '@/ui/Banner';
import { descreverDesvio, relogioDesregulado } from '@/domain/sessao/relogio';
import { useRelogioStore } from '@/stores/relogioStore';

export function RelogioDesreguladoBanner({ desvioMs }: { desvioMs: number | null }) {
  if (desvioMs === null || !relogioDesregulado(desvioMs)) return null;
  return (
    <Banner
      tone="aviso"
      label="Relógio do computador"
      className="mb-3"
      title={`O relógio deste computador está ${descreverDesvio(desvioMs)}`}
      description="O app continua funcionando, mas horários registrados podem sair errados. Avise o TI para acertar data, hora e fuso (Brasília) e ativar a sincronização automática."
    />
  );
}

export function RelogioDesreguladoBannerConectado() {
  const desvioMs = useRelogioStore((s) => s.desvioMs);
  return <RelogioDesreguladoBanner desvioMs={desvioMs} />;
}
